import React, { createContext, useContext, useState, useRef } from 'react';

const AudioPlayerContext = createContext();

export const useAudioPlayer = () => {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within an AudioPlayerProvider');
  }
  return context;
};

export const AudioPlayerProvider = ({ children }) => {
  const [currentPlayingId, setCurrentPlayingId] = useState(null);
  const audioElements = useRef({});

  const registerAudioElement = (id, audioElement) => {
    audioElements.current[id] = audioElement;
  };

  const unregisterAudioElement = (id) => {
    delete audioElements.current[id];
  };

  const playAudio = (id) => {
    // console.log('playAudio called with id:', id);
    // console.log('Current audioElements:', Object.keys(audioElements.current));
    
    // 他のすべてのAudio要素を停止
    Object.keys(audioElements.current).forEach(audioId => {
      if (audioId !== id && audioElements.current[audioId]) {
        const audioElement = audioElements.current[audioId];
        // console.log('Stopping audio:', audioId, audioElement);
        
        if (audioElement) {
          audioElement.pause();
          audioElement.currentTime = 0;
        }
      }
    });

    // 新しいプレイヤーを再生
    setCurrentPlayingId(id);
    // console.log('Set currentPlayingId to:', id);
  };

  const stopAudio = (id) => {
    if (currentPlayingId === id) {
      setCurrentPlayingId(null);
    }
  };

  const pauseAudio = (id) => {
    if (currentPlayingId === id) {
      setCurrentPlayingId(null);
    }
  };

  const value = {
    currentPlayingId,
    registerAudioElement,
    unregisterAudioElement,
    playAudio,
    stopAudio,
    pauseAudio,
  };

  return (
    <AudioPlayerContext.Provider value={value}>
      {children}
    </AudioPlayerContext.Provider>
  );
};
